import Swiper, { Navigation, Pagination, Mousewheel, EffectCoverflow, Autoplay } from 'swiper';
Swiper.use([ Navigation, Pagination, Mousewheel, EffectCoverflow, Autoplay]);

export function sliderInit(){
  wrapSlides()
  sliderCards()
  sliderLogos()
  sliderGrid()
  sliderTestimonials()
  filterSliderItems()
}

function wrapSlides() {
  $(".swiper-container .card, .swiper-container .card-event, .swiper-container .card-press, .swiper-container .card-testimonial, .swiper-container .card-flip, .swiper-container .card-flip-cta").each(function(){
    $(this).nextUntil(".card, .card-event, .card-press, .card-testimonial, .card-flip, .card-flip-cta").addBack().wrapAll('<div class="swiper-slide" />');
  });
}

function sliderCards() {
  let sliders = document.querySelectorAll('.swiper--cards, .swiper--plaincards')
  sliders.forEach(function(slider){
    const loop = slider.getAttribute('data-loop') ? true : false;
    let menu = []
    let pagination = $('.swiper-pagination', slider).length && $('.swiper-pagination', slider)[0]
    $('.card', slider).each(function(){ menu.push($(this).attr('data-anchor')) })
    if($('.swiper-slide', slider).length) {
      const swiper = new Swiper(slider, {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        loop: loop,
        coverflowEffect: {
          rotate: 0,
          stretch: -30,
          depth: 100,
          modifier: 2,
          slideShadows: false,
        },
        pagination: {
          el: pagination,
          clickable: true,
          type: 'custom',
          renderCustom: function(swiper, current, total) {
            let text = "";
            let currentanchor = menu[current-1];
            let anchor = "";
            for (let i = 1; i <= total; i++) {
              let classes = "swiper-pagination-bullet";
              if(anchor == menu[i-1]) { classes += ' swiper-pagination-bullet-hidden'; } else { anchor = menu[i-1] }
              if(current == i || currentanchor == menu[i-1]) { classes += ' swiper-pagination-bullet-active'; }
              text += '<span class="' + classes + '"><span>'+ menu[i-1] + '</span></span>';
            }
            return text;
          }/*
          renderBullet: function(index, className) {
            if(!menu[index]) { className += ' swiper-pagination-bullet-hidden' }
            return '<span class="' + className + '"><span>' + menu[index] + "</span></span>";
          },*/
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        slidesPerView: 'auto',
        mousewheel: {
          invert: false,
          forceToAxis: true,
        }
      })
    }
  })
}

function sliderLogos() {
  let sliders = document.querySelectorAll('.swiper--logos')
  sliders.forEach(function(slider){
    const swiper = new Swiper(slider, {
      grabCursor: true,
      slidesPerView: 'auto',
      autoplay: {
        delay: 5000,
      },
      mousewheel: {
        invert: false,
        forceToAxis: true,
      }
    })
  })
}

function sliderGrid() {
  let sliders = document.querySelectorAll('.swiper--grid')
  sliders.forEach(function(slider){
    let pagination = $('.swiper-pagination', slider).length && $('.swiper-pagination', slider)[0]

    let dataColumns = $(slider).data('columns')
    let columns = dataColumns ? dataColumns : 4
    let breakpoints = {}

    switch(columns){
      case 4:
        breakpoints = {
          ...breakpoints,
          '1024': {
            slidesPerView: 4,
            slidesPerColumn: 2
          }
        }
      case 3:
        breakpoints = {
          ...breakpoints,
          '768': {
            slidesPerView: 3,
            slidesPerColumn: 2,
            spaceBetween: 30
          }
        }
      case 2:
        let space = columns == 2 ? 30 : 24
        breakpoints = {
          ...breakpoints,
          '576': {
            slidesPerView: 2,
            slidesPerColumn: 2,
            spaceBetween: space
          }
        }
    }

    const swiper = new Swiper(slider, {
      grabCursor: true,
      slidesPerView: 1,
      slidesPerColumn: 2,
      slidesPerColumnFill: 'row',
      spaceBetween: 24,
      observer: true,
      observeParents: true,
      mousewheel: {
        invert: false,
        forceToAxis: true,
      },
      breakpoints: breakpoints,
      pagination: {
        el: pagination,
        clickable: true,
        type: 'bullets'
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
  })
}

function sliderTestimonials() {
  let sliders = document.querySelectorAll('.swiper--testimonials')
  sliders.forEach(function(slider){
    let pagination = $('.swiper-pagination', slider).length && $('.swiper-pagination', slider)[0]

    const swiper = new Swiper(slider, {
      grabCursor: true,
      slidesPerView: 1,
      spaceBetween: 60,
      mousewheel: {
        invert: false,
        forceToAxis: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: pagination,
        clickable: true,
        type: 'bullets'
      }
    })
  })
}

function filterSliderItems() {
  $('.slider__filters select').on('input', function(){
    const value = $(this).val()
    const name = $(this).attr('data-name')
    let $grid = $(this).closest('.slider__filters').next('.swiper-container')
    let swiper = $grid[0].swiper;
    if(value==name) {
      $grid.find('.swiper-slide, .noswiper-slide').removeClass('hidden-' + name)
    } else {
      $grid.find('.card').each(function(){
        const $wrap = $(this).closest('.swiper-slide, .noswiper-slide')
        const hasfilter = $(this).hasClass(value)
        $wrap.toggleClass('hidden-' + name, !hasfilter)
      })
    }
    $grid.find('.swiper-slide, .noswiper-slide').each(function(){
      if($(this).is('[class*="hidden-"]')){
        $(this).removeClass('swiper-slide').addClass('noswiper-slide')
      } else {
        $(this).removeClass('noswiper-slide').addClass('swiper-slide')
      }
    })
    swiper.update()
  })
}

